import * as angular from "angular";
import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {lastValueFrom, Observable, take} from 'rxjs';
import {map, switchMap} from 'rxjs/operators';
import {FirebaseAuthResponseModel} from "./models/firebase-auth-response.model";
import {getApp} from "firebase/app";
import {getDatabase} from "firebase/database";
import {getAuth, signInWithCustomToken} from "firebase/auth";
import {FirebaseApp} from "@firebase/app";
import {Database} from "@firebase/database";

@Injectable({providedIn: 'root'})
export class FirebaseAppService {

  public channel: FirebaseAuthResponseModel;
  public firebaseApp: FirebaseApp;
  public database: Database

  constructor(@Inject(HttpClient) private http: HttpClient,
              private $q) {
  }

  initFirebase(siteId: string) {

    const request$ = this.http
      .get<FirebaseAuthResponseModel>(`/sites/${siteId}/channel`)
      .pipe(
        map((channel: FirebaseAuthResponseModel) => {
          this.channel = channel;
          this.firebaseApp = getApp(channel.appName);
          this.database = getDatabase(this.firebaseApp);

          const auth = getAuth(this.firebaseApp);
          // return signInWithCustomToken(auth, channel.token);

          signInWithCustomToken(auth, channel.token);
          return channel;
        }),
        take(1)
      );

    return lastValueFrom<FirebaseAuthResponseModel>(request$);
  }

  destroyFirebase() {
    if (this.channel && this.firebaseApp) {
      const auth = getAuth(this.firebaseApp);

      this.channel = null;
      this.firebaseApp = null;
      this.database = null;

      return auth.signOut();
    } else {
      return this.$q.all([]);
    }
  }

  // async getSiteChannel(siteId: string): Promise<FirebaseAuthResponseModel> {
  //   const request$ = this.http
  //     .get<FirebaseAuthResponseModel>(`/sites/${siteId}/channel`).pipe(take(1));
  //
  //   return await lastValueFrom<FirebaseAuthResponseModel>(request$);
  // }

}

